<script>
export default {
  name: "feet",
  computed: {
    year() {
      return new Date().getFullYear()
    }
  }
}
</script>

<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          {{ year }} © DNA Express Logistics
        </div>
        <div class="col-md-6">
          <div class="text-md-end footer-links d-none d-md-block">
            <a href="#" target="_blank" rel="noopener noreferrer">by Xander Studios</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
